import { StoreContext } from '../StoreProvider';
import videojs from 'video.js';
import { useContext, useEffect } from 'react';

const Fullscreen = () => {
    const { customerData, player } = useContext(StoreContext);

    useEffect(() => {
        if (!player) {
            return;
        }
        addFullscreenButton();
    }, [player]);

    const onFullscreenButton = () => {
        window.parent.postMessage({ event: 'TOGGLE_FULLSCREEN' }, '*');
    }

    const addFullscreenButton = () => {
        if (!customerData?.theVideoGramStore?.player?.showFullscreen) {
            return;
        }

        const videoJsButtonClass = videojs.getComponent('Button');
        const concreteButtonClass = videojs.extend(videoJsButtonClass, {
            constructor: function () {
                videoJsButtonClass.call(this, player);
            },
            handleClick: function () {
                onFullscreenButton();
            }
        });

        const shareButton = player.controlBar.addChild(new concreteButtonClass());
        shareButton.addClass('vjs-share');
    }

    return null;
}

export default Fullscreen;
